import { useRef, useState, useEffect } from "react";
import Pagination from "../CommonComponents/Pagination";
import Spinner from "../CommonComponents/Spinner";
import { SearchInput } from "../CommonComponents/Components";
import { Container } from "../CommonComponents/DataCard";
import EmployeeDataCard from "./EmployeeDataCard";
import EmployeeProfileModal from "./EmployeeProfileModal";
import { searchEmployees } from "../../services/EmployeeService";

function EmployeeGrid() {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [query, setQuery] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // NOVO

    const inputRef = useRef(null);

    useEffect(() => {
        async function fetchEmployees() {
            setLoading(true);
            setError("");
            try {
                const data = await searchEmployees(query, currentPage, 10);
                setEmployees(data.content);
                setTotalPages(data.totalPages);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        fetchEmployees();
    }, [query, currentPage]);

    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <Container style={{ padding: "10px" }}>
            <SearchInput
                ref={inputRef}
                type="text"
                placeholder="Pretraži zaposlenike..."
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setCurrentPage(0);
                }}
            />

            {loading ? (
                <Spinner />
            ) : (
                employees.map((emp) => (
                    <EmployeeDataCard
                        key={emp.id}
                        employee={emp}
                        onClick={() => setSelectedEmployeeId(emp.id)} // klik postavlja ID
                    />
                ))
            )}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }}
            />
            {selectedEmployeeId && (
                <EmployeeProfileModal
                    employeeId={selectedEmployeeId}
                    onClose={() => setSelectedEmployeeId(null)}
                />
            )}
        </Container>
    );
}

export default EmployeeGrid;
